import * as React from 'react';
import withStyles from 'react-jss';
import * as lodash from 'lodash';

import DetailsCard from './DetailsCard';
import moment from 'moment';
import { formatDateTime } from '../../../utils/utils';
import { Tabs, Table, Image, Tooltip } from 'antd';
import { WarningFilled } from '@ant-design/icons';
import ChatComponent from '../../../common/ChatComponent';
import { useTranslation } from 'react-i18next';

const styles = (theme) => ({
  tabsCardsContainer: {
    backgroundColor: '#ffffff',
    // border: '1px solid #D9D9D9',
    // borderTop: '0',
    borderRadius: '4px',
    padding: '0',
    overflowX: 'scroll',
  },
  tabsContainer: {
    boxSizing: 'border-box',
    backgroundColor: '#FFFFFF',
    // border: '1px solid rgba(0, 0, 0, 0.06)',
    borderRadius: '8px',
    flex: 'none',
    order: '0',
    alignSelf: 'stretch',
    flexGrow: '0',
    '& .ant-tabs-nav-list': {
      padding: '0.33% 0 0.33% 2%',
    },
    '& .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn': {
      color: '#1890FF !important',
    },
    '& .ant-tabs-ink-bar': {
      position: 'absolute',
      background: '#1890FF',
    },
    '& .ant-tabs-content': {
      height: '100% !important',
    },
    '& .ant-tabs-content-holder': {
      height: '100% !important',
    },
    // padding: '5px 10px',
    margin: '1% 0.5%',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.25)',
    height: '96%',
    overflowY: 'scroll',
    // borderRadius: '4px'
  },
  borderlessTabContainer: {
    backgroundColor: '#FFFFFF',
    flex: 'none',
    order: '0',
    alignSelf: 'stretch',
    flexGrow: '0',
    '& .ant-tabs-nav-list': {
      padding: '0.33% 0 0.33% 2%',
    },
    '& .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn': {
      color: '#1890FF !important',
    },
    '& .ant-tabs-ink-bar': {
      position: 'absolute',
      background: '#1890FF',
    },
  },
  settingsIcon: {
    display: 'flex',
    color: 'rgba(0, 0, 0, 0.85)',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    margin: '0 1rem',
  },
});

const PRIMARY_TRIP = 'primary';

const TabSection = (props: any) => {
  const { TabPane } = Tabs;
  const {
    tabs,
    classes,
    data,
    executionStatusList,
    callLogsData,
    reload,
    metadata,
    currentActiveTab,
    handleCurrentActiveTab,
    handleCustomColumModalSubmit,
    columnList,
    taskColumnList,
    actionList,
    showPickupTaskTab,
    getPropsByHeader = () => {},
    getCustomDetailsCard,
    headerList,
    fullHeadersList,
    isSuperAdmin,
    activeUpdatesList,
    updatesList,
    autoRefreshTrip,
  } = props;
  const activeTab = new URLSearchParams(window.location.search).get('activeTab');
  const [visible, setVisible] = React.useState(false);
  const [imageData, setImageData] = React.useState(null);
  const { t } = useTranslation();

  const getDataSourceByTabHeader = (data_header) => {
    switch (data_header) {
      case 'Tracking':
      case 'CN Tracking':
      case 'Consignment Log':
        return data?.events;
      case 'Job Tracking':
        return data?.job_events;
      case 'Item Details':
        return data?.items_detail;
      case 'Call Logs':
        return callLogsData;
      default:
        return data;
    }
  };

  const setImage = (data = null) => {
    setVisible(!visible);
    setImageData(data);
  };

  const renderImage = (data) => {
    if (!data) return t('No Data');
    return <span onClick={() => setImage(data)}>View</span>;
  };

  const getExecutionStatusPrettyNames = (key) => {
    const obj = executionStatusList?.find((lis) => lis.code === key);
    return obj?.name || null;
  };

  const getColumnsForTable = (columnsToShow) => {
    // const { showThirdParty } = this.props;
    // const columnsToShow = getColumnsToShowCNDetailsTracking(showThirdParty);
    const columns = columnsToShow?.map((col) => {
      return (
        col && {
          dataIndex: col.id,
          title: col.pretty_name,
          width: 80,
          render: (x, record, index) => {
            switch (col.key) {
              case 'event_string':
                return (
                  <div>
                    <div> {x}</div>
                    {record.is_partial_pickedup ? (
                      <Tooltip title="Partially Pickedup">
                        <WarningFilled
                          style={{
                            fontSize: 18,
                            color: '#EC544A',
                            marginLeft: 8,
                          }}
                        />
                      </Tooltip>
                    ) : null}
                  </div>
                );
              case 's_no':
                return <div>{index + 1}</div>;
              case 'event_time':
                return x ? moment(x).format('DD/MM/YYYY, HH:mm') : null;
              case 'execution_status':
                return getExecutionStatusPrettyNames(x);
              case 'poa_image':
                return x ? renderImage(x) : null;
              case 'employee':
                return record.employee_username
                  ? `${record.employee_username} (${
                      record.employee_code ? record.employee_code : ''
                    })`
                  : '';
              case 'courier_partner':
                return (
                  <div>
                    <div> {x} </div>
                    {record.courier_account && <div> {record.courier_account} </div>}
                  </div>
                );
              case 'event_proof_images':
                if (Array.isArray(record.event_proof_images) && record.event_proof_images.length) {
                  return renderImage(record.event_proof_images);
                }
                return null;
              case 'pod_image':
                return renderImage(x);
              case 'arrival_time':
                return formatDateTime(record[col.id]);
              default:
                return x;
            }
          },
        }
      );
    });
    return columns.filter((column) => column);
  };

  const tableView = (tab_header, columns, actions_to_show) => {
    return (
      <TabPane tab={t(tab_header)} key={tab_header}>
        <div className={classes.tabsCardsContainer}>
          <Table
            locale={{ emptyText: t('No data found') }}
            dataSource={getDataSourceByTabHeader(tab_header)}
            pagination={false}
            columns={getColumnsForTable(columns)}
            {...getPropsByHeader(tab_header)}
          />
        </div>
      </TabPane>
    );
  };

  const chatView = (tab_header, tab_details) => {
    return (
      <TabPane tab={t(tab_header)} key={tab_header}>
        <ChatComponent details={tab_details} tripId={data?.tripDetails?.id} />
      </TabPane>
    );
  };

  const getDefaultViewDataByHeader = (tab_header) => {
    switch (tab_header) {
      case 'Trip Details':
        return data?.tripDetails;
      default:
        return data;
    }
  };

  const defaultView = (tab_header, details) => {
    return (
      <TabPane tab={t(tab_header)} key={tab_header}>
        <div className={classes.tabsCardsContainer}>
          {details?.map((card) => {
            return (
              <DetailsCard
                key={card.header}
                title={t(card.header) as string}
                data={getDefaultViewDataByHeader(tab_header)}
                columns={card.columns}
                getCustomDetailsCard={getCustomDetailsCard}
              />
            );
          })}
        </div>
        <div>
          <div style={{ display: 'none' }}>
            {/* <Image.PreviewGroup
              preview={{
                visible,
                onVisibleChange: (vis) => setImage(),
              }}
            >
              {Array.isArray(imageData) ? (
                imageData?.map((url) => <Image src={url} placeholder="true" />)
              ) : (
                <Image src={imageData} placeholder="true" />
              )}
            </Image.PreviewGroup> */}
          </div>
        </div>
      </TabPane>
    );
  };

  const renderTab = (tab: any) => {
    switch (tab.type) {
      case 'table':
        return tableView(tab.tab_header, tab?.details[0]?.columns, tab.actions_to_show);
      case 'chat':
        return chatView(tab.tab_header, tab?.details);

      default:
        return defaultView(tab.tab_header, tab.details);
    }
  };

  const getTabToRender = (tabHeader, tab) => {
    switch (tabHeader) {
      case 'Consignments':
        return renderTab(tab);
      case 'Drops':
        return data?.data?.tripDetails?.trip_type !== PRIMARY_TRIP ? null : renderTab(tab);
      case 'Comments':
        return (data?.tripDetails?.extra_details?.third_party_vendor_id ||
          data?.tripDetails?.extra_details?.vehicle_vendor_id) ? renderTab(tab) : null;
      default:
        return renderTab(tab);
    }
  };

  return (
    <Tabs
      // tabBarExtraContent={renderActionsByTabHeader()}
      defaultActiveKey={`${activeTab}`}
      className={`${classes.tabsContainer} ${classes.setBg}`}
      onChange={(activeKey) => {
        if (handleCurrentActiveTab) {
          handleCurrentActiveTab(activeKey);
        }
      }}
    >
      {tabs?.map((tab) => {
        return getTabToRender(tab.tab_header, tab);
      })}
    </Tabs>
  );
};

export default withStyles(styles, { injectTheme: true })(TabSection);
